import React from "react";
import { Text, Heading, Box, Avatar } from "@cruk/cruk-react-components";

import { useBrandContext } from "@fwa/src/contexts/BrandContext";
import { imagePathFromImageType } from "@fwa/src/services/imageService";

import sharedStyles from "@fwa/src/components/styles.module.css";
import styles from "@fwa/src/components/RestrictionSection/styles.module.css";

import { type RestrictionType } from "@fwa/src/types";

const restrictionFrameSu2c = "/assets/images/img/arrows.jpg";
const noneRestrictedImg = "/assets/images/img/none-restricted-all-cancers.png";

export function RestrictionSection({
  restriction,
}: {
  restriction: RestrictionType | null;
}) {
  const noneRestrictedPage: RestrictionType = {
    restrictionCode: "undefined",
    description:
      "Cancer is complex. There are over 200 types of cancer, most of which have different biology and behaviour. With your support, our dedicated researchers can continue to discover better ways to prevent, detect and treat this disease, and bring about a world where everybody lives longer, better lives, free from the fear of cancer.",
    hidden: false,
    title: "All Cancer Types",
    image: {
      uniqueId: "",
      url: noneRestrictedImg,
      width: 120,
      height: 120,
    },
  };
  const [brandName] = useBrandContext();
  const isSu2c = brandName === "su2c";
  const isBowelBabe = brandName === "bowelbabe";
  const restrictionObject = restriction ?? noneRestrictedPage;
  const restrictionImageUrl = restrictionObject.image
    ? imagePathFromImageType(restrictionObject.image)
    : "";
  const { title, description, image } = restrictionObject;

  if (!title || !description || !image) return null;

  // bowelbabe has no image at the bottom
  const restrictionImageSrc = isBowelBabe
    ? ""
    : isSu2c
      ? restrictionFrameSu2c
      : null;

  return (
    <Box
      padding="none"
      backgroundColor="background-light"
      data-component="page-restrictions"
    >
      <div className={styles["text-wrapper"]}>
        <Box>
          <div className={sharedStyles["row"]}>
            <Box marginRight="s" marginBottom="none">
              <Avatar size="l" url={restrictionImageUrl} />
            </Box>
            <div className={sharedStyles["column-space-around"]}>
              <Text margin="none" textColor="text-dark">
                CAUSE
              </Text>
              <Heading margin="none" h2 textSize="xl">
                {restrictionObject.title}
              </Heading>
            </div>
          </div>
        </Box>
        <Text paddingBottom={isSu2c ? "l" : "s"}>{description}</Text>
      </div>
      {restrictionImageSrc ? (
        <div className={styles["image-wrapper"]}>
          <img
            alt=""
            loading="lazy"
            src={restrictionImageSrc}
            className={styles["restriction-image"]}
          />
        </div>
      ) : null}
    </Box>
  );
}

export default RestrictionSection;
